import React, { useState, useEffect } from 'react';
import { Card, Typography, Tag, Divider, Space, Empty } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

const { Title, Text } = Typography;

const Archive = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const storedArticles = JSON.parse(localStorage.getItem('articles')) || [];
    setArticles(storedArticles);
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const storedArticles = JSON.parse(localStorage.getItem('articles')) || [];
      setArticles(storedArticles);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const groupArticlesByMonth = (articles) => {
    const grouped = {};
    
    articles.forEach(article => {
      const date = new Date(article.date);
      const monthKey = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      
      if (!grouped[monthKey]) {
        grouped[monthKey] = [];
      }
      
      grouped[monthKey].push(article);
    });

    return Object.entries(grouped).sort((a, b) => {
      const dateA = new Date(a[0].replace('年', '-').replace('月', '-01'));
      const dateB = new Date(b[0].replace('年', '-').replace('月', '-01'));
      return dateB - dateA;
    });
  };

  const groupedArticles = groupArticlesByMonth(articles);

  return (
    <div className="archive-layout">
      <AppHeader />
      <div className="archive-main-content">
        <div className="archive-container">
          <Title level={2} className="archive-title">文章归档</Title>

          {articles.length === 0 ? (
            <Empty
              description="暂无文章"
              className="empty-state"
            />
          ) : (
            groupedArticles.map(([month, monthArticles]) => (
              <Card
                key={month}
                className="archive-card"
                hoverable
                bodyStyle={{ padding: '24px' }}
                headStyle={{ borderBottom: 'none', padding: '0 0 16px 0' }}
              >
                <div className="archive-month-section">
                  <Space align="center">
                    <span className="info-icon">ⓘ</span>
                    <Title level={4} className="archive-month">
                      {month}
                    </Title>
                  </Space>
                  <Divider style={{ margin: '16px 0' }} />

                  <div className="articles-list">
                    {monthArticles.map((article) => (
                      <div key={article.id} className="article-item">
                        <a href={`/article/${article.id}`} className="article-title">
                          <Text strong>{article.title}</Text>
                        </a>
                        <div className="article-meta">
                          <Text type="secondary" style={{ marginRight: '8px' }}>
                            {article.date}
                          </Text>
                          <Text type="secondary">◇</Text>
                          <div className="article-tags">
                            {article.tags.map((tag, tagIndex) => (
                              <Tag key={tagIndex} color="blue" className="article-tag">
                                {tag}
                              </Tag>
                            ))}
                          </div>
                        </div>
                        <div className="article-abstract">
                          <Text type="secondary" className="abstract-text">
                            {article.abstract}
                          </Text>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            ))
          )}
        </div>
      </div>
      <AppFooter />
    </div>
  );
};

export default Archive;